import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { ArrowUp } from "lucide-react";

export default function BackToTop() {
  const [visible, setVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => {
      const doc = document.documentElement;
      const scrollable = (doc.scrollHeight || document.body.scrollHeight) - window.innerHeight;
      const threshold = Math.max(1, scrollable * 0.5); // 50% of the page height
      setVisible(window.scrollY >= threshold);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, [location.pathname]);

  // Keep dashboard clean
  if (location.pathname.startsWith("/admin")) return null;

  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <button
      type="button"
      onClick={toTop}
      aria-label="Scroll to top"
      data-testid="back-to-top-button"
      aria-hidden={!visible}
      tabIndex={visible ? 0 : -1}
      className={`fixed right-4 sm:right-5 bottom-20 sm:bottom-24 z-40 w-11 h-11 rounded-full
        bg-white text-pink-600 border border-slate-200 shadow-lg
        flex items-center justify-center
        transition-opacity duration-200 ease-out
        hover:bg-pink-50 hover:scale-105 active:scale-95
        focus:outline-none focus-visible:ring-2 focus-visible:ring-pink-500 focus-visible:ring-offset-2
        ${visible ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"}`}
    >
      <ArrowUp className="w-5 h-5" strokeWidth={2.5} />
    </button>
  );
}
